import React from 'react';
import { TextField } from 'ffsdk';
import { ServiceSelectField } from 'components';

export function Form(): React.ReactElement {
  return (
    <div className="row">
      <div className="col-md-6">
        <div className="form-row">
          <TextField name="title" label="Nosaukums" required className="col" />
        </div>
        <div className="form-row">
          <ServiceSelectField name="services" label="Pakalpojumi" isMulti className="col" required />
        </div>
      </div>
    </div>
  );
}
